import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "react-bootstrap";
import { MdMeetingRoom } from "react-icons/md";

import { Header } from "../../common";
import StatusTimelineTab from "./components/StatusTimelineTab";
import OccupancyHistoryTab from "./components/OccupancyHistoryTab";
import MyOccupanciesTab from "./components/MyOccupanciesTab";

const MeetingRoomsView = ({
  activeTab,
  handleTabChange,
  roomList,
  userList,
  user,
  bookRoom,
  bookPending,
  occupancyHistoryList,
  occupancyHistoryPagination,
  getOccupancyHistory,
  checkOutRoom,
  checkoutPending,
  cancelBooking,
  currentOccupancyList,
  getCurrentOccupancy,
  occupancyHistoryPending,
  locationList,
  occupancyHistoryPage,
  setOccupancyHistoryPage,
  myOccupancyPage,
  setMyOccupancyPage,
  myOccupancySelectedDate,
  setMyOccupancyFilters,
  occupancyHistoryFilters,
  setOccupancyHistoryFilters,
}) => {
  return (
    <div className="room-management-page main__body padding">
      <Header label="Meeting Rooms" Icon={MdMeetingRoom} />

      <Tabs
        activeKey={activeTab}
        onSelect={handleTabChange}
        id="meeting_rooms_tabs"
        className="table_tabs mb-4 mt-3"
      >
        <Tab eventKey="status" title="OCCUPANCY & TIMELINE">
          <StatusTimelineTab
            roomList={roomList}
            userList={userList}
            user={user}
            currentOccupancyList={currentOccupancyList}
            getCurrentOccupancy={getCurrentOccupancy}
            occupancyHistoryList={occupancyHistoryList}
            getOccupancyHistory={getOccupancyHistory}
            checkOutRoom={checkOutRoom}
            checkoutPending={checkoutPending}
            cancelBooking={cancelBooking}
            occupancyHistoryPending={occupancyHistoryPending}
            locationList={locationList}
            bookRoom={bookRoom}
            bookPending={bookPending}
          />
        </Tab>
        <Tab eventKey="my-occupancies" title="MY OCCUPANCIES">
          <MyOccupanciesTab
            user={user}
            occupancyHistoryList={occupancyHistoryList}
            occupancyHistoryPagination={occupancyHistoryPagination}
            cancelBooking={cancelBooking}
            checkOutRoom={checkOutRoom}
            getCurrentOccupancy={getCurrentOccupancy}
            getOccupancyHistory={getOccupancyHistory}
            myOccupancyPage={myOccupancyPage}
            setMyOccupancyPage={setMyOccupancyPage}
            myOccupancySelectedDate={myOccupancySelectedDate}
            setMyOccupancyFilters={setMyOccupancyFilters}
          />
        </Tab>
        <Tab eventKey="history" title="OCCUPANCY HISTORY">
          <OccupancyHistoryTab
            roomList={roomList}
            occupancyHistoryList={occupancyHistoryList}
            occupancyHistoryPagination={occupancyHistoryPagination}
            getOccupancyHistory={getOccupancyHistory}
            occupancyHistoryPending={occupancyHistoryPending}
            locationList={locationList}
            occupancyHistoryPage={occupancyHistoryPage}
            setOccupancyHistoryPage={setOccupancyHistoryPage}
            occupancyHistoryFilters={occupancyHistoryFilters}
            setOccupancyHistoryFilters={setOccupancyHistoryFilters}
          />
        </Tab>
      </Tabs>
    </div>
  );
};

MeetingRoomsView.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  roomList: PropTypes.array.isRequired,
  userList: PropTypes.array.isRequired,
  user: PropTypes.object,
  bookRoom: PropTypes.func.isRequired,
  bookPending: PropTypes.bool,
  occupancyHistoryList: PropTypes.array.isRequired,
  occupancyHistoryPagination: PropTypes.object,
  getOccupancyHistory: PropTypes.func.isRequired,
  checkOutRoom: PropTypes.func.isRequired,
  checkoutPending: PropTypes.bool,
  cancelBooking: PropTypes.func.isRequired,
  currentOccupancyList: PropTypes.array.isRequired,
  getCurrentOccupancy: PropTypes.func.isRequired,
  occupancyHistoryPending: PropTypes.bool,
  locationList: PropTypes.array.isRequired,
  occupancyHistoryPage: PropTypes.number,
  setOccupancyHistoryPage: PropTypes.func,
  myOccupancyPage: PropTypes.number,
  setMyOccupancyPage: PropTypes.func,
  myOccupancySelectedDate: PropTypes.string,
  setMyOccupancyFilters: PropTypes.func,
  occupancyHistoryFilters: PropTypes.object,
  setOccupancyHistoryFilters: PropTypes.func,
};

export default MeetingRoomsView;
